// Copyright (C) 2020-2023 Berkadia Commercial Mortgage, LLC - All Rights Reserved
import React, { Component } from 'react'
import { withRouter, Link, useLocation, BrowserRouter as Router } from 'react-router-dom'
import '../../css/AddedStyles.css'
import emailListContext from '../../context/context'
import SaveEmailList from './SaveEmailList/SaveEmailList'
import PublishtoPardot from './PublishtoPardot/PublishtoPardot'
import DownloadEmailListButton from './DownloadEmailListButton/DownloadEmailListButton'

class TopMenu extends Component {

    static contextType = emailListContext

    constructor(props) {
        super(props)
        this.state = {
            sfUserId: (new URLSearchParams(window.location.search)).get('userid'),
            listContext: {}
        }
        this.child = React.createRef()
    }

    componentDidMount() {
        this.setState({ listContext: this.context })
    }

    goBackToEmailListInitialPage = () => {

        const currentURL = window.location.href
        const paramId = (new URLSearchParams(window.location.search)).get('Id')

        if (currentURL !== undefined && currentURL.includes('EmailListDetails')) {
            const { setShowListDetails, listType } = this.state.listContext

            let queryParam = "?listType=" + listType + "&Id=" + paramId + "&userid=" + this.state.sfUserId
            this.props.history.push({
                pathname: '/EmailLists',
                search: queryParam
            })

            setShowListDetails(false)
        } else {
            this.props.history.push(`/EmailListInitialPage?userid=${this.state.sfUserId}`)
        }
    }

    render() {
        return (
            <div className="sticky-top z-sticky ">
                <header className="text-white theme-dark overflow-hidden">
                    <nav className="flex flex-col md:flex-row items-center px-6 py-4">
                        <div>
                            <a data-testid="TopMenu_ankGoBack_test" className="btn btn-link text-white -ml-5" onClick={this.goBackToEmailListInitialPage}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-4">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.9137 3.89703C12.2066 3.60414 12.2066 3.12926 11.9137 2.83637C11.6208 2.54348 11.1459 2.54348 10.853 2.83637L2.22386 11.4655C2.20919 11.48 2.1951 11.495 2.18165 11.5106C2.13215 11.568 2.09277 11.6311 2.0635 11.6975C2.02267 11.79 2 11.8924 2 12C2 12.0012 2 12.0023 2.00001 12.0035C2.00042 12.0948 2.0174 12.186 2.05095 12.2723C2.08751 12.3663 2.14375 12.4544 2.21967 12.5304L10.853 21.1637C11.1459 21.4566 11.6208 21.4566 11.9137 21.1637C12.2066 20.8708 12.2066 20.3959 11.9137 20.103L4.56063 12.75H21.25C21.6642 12.75 22 12.4142 22 12C22 11.5858 21.6642 11.25 21.25 11.25H4.56069L11.9137 3.89703Z" fill="currentColor" />
                                </svg>
                                <span className="">ListGen</span></a>
                        </div>
                        <div className="flex-11 mx-autos flex-grow text-center mx-auto">
                            {this.context.emailList.listName}
                            {/* {this.props.listType &&
                                <span className="capitalize">List Creator - Based on {this.props.listType}</span>} */}
                        </div>
                        <div className="px-4">
                            <DownloadEmailListButton></DownloadEmailListButton>
                        </div>
                        {!this.context.isListPublished && <div>
                            <SaveEmailList className="btn mr-5 btn-primary" />
                            <PublishtoPardot className="btn btn-primary" />
                        </div>}
                        {this.context.isListPublished && <div>
                            <label>List Published</label>
                        </div>}

                    </nav>
                </header>
            </div >

        )

    }
}

export default withRouter(TopMenu)
